<template>
  <InsideContent
    class="transactions-purchases"
    :title="$t('APP.TRANSACTIONS.PURCHASES')"
  >
    <Card>
      <div class="flex-container align-justify align-middle">
        <TransactionsPurchasesSearch
          :errors="transactionsFormErrors"
          @search="searchByToken"
        />

        <div class="download-transactions-csv">
          <ElButton plain @click="openModal('downloadCsvModal')">
            {{ $t('APP.TRANSACTIONS.MONTHLY_CSV_EXPORT') }}
          </ElButton>

          <SendEmailPurchasesCsvModal v-model="downloadCsvModal" />
        </div>
      </div>
    </Card>

    <CardApiError
      v-if="hasError"
      :error-text="$t('APP.TRANSACTIONS.API_ERROR')"
      @retry="getPurchases"
    />

    <Card v-else-if="purchases.length" no-padding>
      <TransactionsPurchasesTable :purchases="purchases" />
    </Card>

    <Card v-else :is-loading="purchasesLoading">
      {{ $t('APP.TRANSACTIONS.NO_TRANSACTIONS') }}
    </Card>

    <TransactionsPagination
      :prev-page-url="prevPageUrl"
      :next-page-url="nextPageUrl"
      :is-loading="purchasesLoading"
      @change="setCurrentPage"
    />
  </InsideContent>
</template>

<script>
import { Apps } from '@/api/api';

import TransactionsPagination from '../TransactionsPagination';
import TransactionsPurchasesSearch from './TransactionsPurchasesSearch';
import TransactionsPurchasesTable from './TransactionsPurchasesTable';
import SendEmailPurchasesCsvModal from '../monthly-csv-export/SendEmailPurchasesCsvModal';
import Card from '@@/common/Card';
import InsideContent from '@@/common/layout/InsideContent';
import CardApiError from '@@/common/CardApiError';
import packageNameWatch from '@/mixins/apps/packageNameWatch';
import packageName from '@/mixins/packageName';
import lang from '@/mixins/lang';
import modal from '@/mixins/modal';
import permissions from '@/mixins/permissions';
import { mapGetters } from 'vuex';
import { APP_DETAILS } from '@/store/types';

export default {
  name: 'TransactionsPurchases',

  components: {
    TransactionsPagination,
    TransactionsPurchasesSearch,
    TransactionsPurchasesTable,
    Card,
    InsideContent,
    CardApiError,
    SendEmailPurchasesCsvModal,
  },

  mixins: [packageNameWatch, packageName, lang, permissions, modal],

  data() {
    return {
      purchases: [],
      purchasesLoading: false,
      prevPageUrl: null,
      nextPageUrl: null,
      filters: {
        page_no: 1,
        page_size: 20,
        token: null,
      },
      transactionsFormErrors: null,
      hasError: false,
      downloadCsvModal: false,
    };
  },

  computed: {
    ...mapGetters({ app: APP_DETAILS }),
  },

  created() {
    if (!this.hasFinance(this.packageName)) {
      this.$router.replace({ name: 'apps-view' });
      return;
    }
    this.getInfo();
  },

  methods: {
    getInfo() {
      this.getPurchases();
    },

    getPurchases() {
      this.purchasesLoading = true;
      this.hasError = false;
      return Apps.getPurchases({
        packageName: this.packageName,
        ...this.filters,
      })
        .then(({ body: { purchases = [], prev, next } }) => {
          this.purchasesLoading = false;
          this.purchases = [...purchases];
          this.prevPageUrl = prev;
          this.nextPageUrl = next;
          this.transactionsFormErrors = null;
        })
        .catch(({ body: { message, errors } = {} }) => {
          this.purchasesLoading = false;
          this.hasError = true;

          if (message) {
            this.$message.error(message);
          }

          if (errors) {
            this.transactionsFormErrors = [...errors];
          }
        });
    },

    searchByToken(token) {
      this.filters = {
        ...this.filters,
        page_no: 1,
        token,
      };
      this.getPurchases();
    },

    setCurrentPage(page) {
      this.filters = { ...this.filters, page_no: page };
      this.getPurchases();
    },
  },
};
</script>

<style lang="scss" scoped>
.transactions-purchases {
  &__actions.row {
    margin: 0;
  }
}
</style>
